import { Row, Col, Card, Button } from "react-bootstrap";
import { useState } from "react";
import Leftmenubar from "../Components/Left_menubar";
import BackArrow from "../../../components/backArrow";
import RedoIcon from "@mui/icons-material/Redo";
import Nodata from "../../../components/Nodata";
import { getAsset } from "../../../helpers/helper";
import Loader from "../../../components/Loader";
import ShareModel from "../../../components/Sharemodel";
import ShareOption from "../../../components/Shareoption";
import { useMineralAndMiningShopsState } from "../../../hooks/useMineralAndMiningShopsState";
import noImagePlaceholder from "../../../assets/images/dummy/no_image_placeholder.png";

const MineralAndMiningShops = () => {
  const {
    navigate,
    mineralShop,
    isloading,
    showshare,
    show,
    setShow,
    userimg,
    handleCloseshare,
    handleClosemodal,
    handleShowshare,
  } = useMineralAndMiningShopsState();

  const [shareShopId, setShareShopId] = useState(null);

  return (
    <Row className="business-dashboard-shop-layout">
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel handleClosemodal={handleClosemodal} show={show} shopid={shareShopId} handleShowshare={handleShowshare} />
      <Col lg={3} md={3}>
        <Leftmenubar userimg={userimg} />
      </Col>
      <Col lg={8} md={8} className="screenHeight b-radius border_2 ms-lg-3 ms-md-3 col-12 business-dashboard-content">
        <Row>
          <Col xl="4" lg="3" md="3" sm="3" xs="6" className="text-sm-center text-md-start">
            <div className="ms-4 ms-sm-0 pt-4 pb-2">
              <BackArrow back="/SellingSide" mystyle="d-none d-lg-block" />
            </div>
          </Col>
          <Col xl="4" lg="5" md="5" sm="5" xs="6">
            <div>
              <h5 className="font-primary mt-4 res-manage-btn">Manage Your Shops Here</h5>
            </div>
          </Col>
          <Col lg="4" md="3" sm="3" xs="5" className=" text-sm-end text-lg-end text-md-end">
            <div className="mt-4 ps-lg-4 ps-md-4 p-xs-2">
              <Button className=" ms-5 ms-sm-0" onClick={() =>
                navigate("/mineral-mining-form")
              } >Create New</Button>
            </div>
          </Col>
        </Row>
        {isloading ? (
          <Loader heightsetting="loaderHeight" />
        ) : (
          <Row className="scroll-shops-business noscroll justify-content-center justify-content-sm-between justify-content-md-start">
            {mineralShop && mineralShop.length > 0 ? (
              mineralShop.map((e) => (
                <Col lg="4" xl="3" md="6" sm="5" xs="11" className="mt-1" key={e._id}>
                  <Card className="ShopsCards_business">
                    <div className="fix-img">
                      <img
                        className="c_img"
                        src={
                          e?.image && e?.image !== "N/A"
                            ? getAsset(e?.image)
                            : noImagePlaceholder
                        }
                        alt=""
                        crossOrigin="anonymous"
                        onError={(ev) => {
                          ev.currentTarget.onerror = null;
                          ev.currentTarget.src = noImagePlaceholder;
                        }}
                      />
                    </div>
                    <Card.Body className="p-2">
                      <Card.Title className="font-sm-15 mb-0 pb-1">
                        <div className="d-flex justify-content-between">
                          {e?.shopname.length >= 7 ? e?.shopname.substring(0, 7) + `...` : e?.shopname}

                          <button className="text-white bg-blue share_font" onClick={() => {
                            setShareShopId(e._id);
                            setShow(1);
                          }}>
                            Share <RedoIcon className="share_icon_f" />
                          </button>
                        </div>
                      </Card.Title>
                      <Card.Text className="font-sm font-primary mb-2">
                        {e?.shopaddress.length >= 12 ? e?.shopaddress.substring(0, 12) + `...` : e?.shopaddress}
                      </Card.Text>
                      <button
                        className="viewshop w-100 text-white bg-blue"
                        onClick={() =>
                          navigate(`/rawmaterial-mineralsandmining/${e._id}`)
                        }
                      >
                        Manage Your Shop
                      </button>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <div>
                <Nodata />
              </div>
            )}
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default MineralAndMiningShops;
